import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import SpecialPermitDashboardContainer from './containers/SpecialPermitDashboardContainer';
import * as actions from './action';
import * as c from './constant';

const DashboardContainer = ({ getTotalStats, totalStats }) => {
  const returnPuvData = () => {
    const data = _.get(totalStats, 'item.TYPES.PUV.total_per_status');

    return {
      label: 'PUV',
      total: _.get(totalStats, 'item.TYPES.PUV.total', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'For Assessment (Admin)',
          value: _.get(data, 'FOR ASSESSMENT (ADMIN)', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Assessment (Treasury)',
          value: _.get(data, 'FOR ASSESSMENT (TREASURY)', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Finalized',
          value: _.get(data, 'Finalized', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Waiting for Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Pick-up',
          value: _.get(data, 'FOR PICK-UP', 0),
          borderClassName: 'received',
        },
        {
          label: 'Printed',
          value: _.get(data, 'PRINTED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
      ],
    };
  };

  const returnTricycleData = () => {
    const data = _.get(totalStats, 'item.TYPES.TRICYCLE.total_per_status');

    return {
      label: 'Tricycle',
      total: _.get(totalStats, 'item.TYPES.TRICYCLE.total', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'For Assessment (Admin)',
          value: _.get(data, 'FOR ASSESSMENT (ADMIN)', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Assessment (Treasury)',
          value: _.get(data, 'FOR ASSESSMENT (TREASURY)', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Finalized',
          value: _.get(data, 'Finalized', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Waiting for Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Pick-up',
          value: _.get(data, 'FOR PICK-UP', 0),
          borderClassName: 'received',
        },
        {
          label: 'Printed',
          value: _.get(data, 'PRINTED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnPuvData()} className="mb-3" />
          <DashboardListCard data={returnTricycleData()} />
        </div>
        <div className="col-8 pr-0">
          <SpecialPermitDashboardContainer />
        </div>
      </div>
    </div>
  );
};

DashboardContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DashboardContainer);
